import {
	JSX,
	ChangeEvent,
	useCallback,
	useEffect,
	useRef,
	useState
} from "react";
import { useTranslation } from "react-i18next";

import i18n from "i18next";

import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import FormControlLabel from "@mui/material/FormControlLabel";

import { asTitle } from "utils/Utils";

export type EulaDialogProps = {
	onAccept: () => void;
	onClose: () => void;
};

export default function EulaDialog(
	props: Readonly<EulaDialogProps>
): JSX.Element {
	const { t } = useTranslation();

	const [checked, setChecked] = useState(false);
	const contentRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		fetch(`/eula/${i18n.language}.html`)
			.then(response => response.text())
			.then(setEulaContent);
	}, [i18n.language]);

	function setEulaContent(content: string): void {
		if (contentRef !== null && contentRef.current !== null) {
			contentRef.current.innerHTML = content;
		}
	}

	const setEulaChecked = useCallback(
		(event: ChangeEvent<HTMLInputElement>): void => {
			setChecked(event.target.checked);
		},
		[]
	);

	return (
		<Dialog
			fullWidth={true}
			maxWidth="lg"
			open={true}
			onClose={props.onClose}>
			<DialogContent>
				<div
					style={{
						width: "100%",
						height: "70vh",
						overflowY: "scroll"
					}}
					ref={contentRef}
				/>
				<FormControlLabel
					control={
						<Checkbox checked={checked} onChange={setEulaChecked} />
					}
					label={t("eulaAcceptCheckbox")}
				/>
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={props.onClose} autoFocus>
					{asTitle(t("disagree"))}
				</Button>
				<Button
					variant="contained"
					onClick={props.onAccept}
					disabled={!checked}>
					{asTitle(t("agree"))}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
